import React, { useRef } from 'react';
import assetUrl from '../../utils/assetUrl';

const HeroSection = ({ onNewsletterClick, isRetro = false }) => {
    
    const mobileLogoStyle = `
      .mobile-logo {
        display: none;
      }
      @media (max-width: 768px) {
        .mobile-logo {
          display: flex !important;
          position: absolute;
          left: 0;
          width: 100%;
          justify-content: center;
          z-index: 10;
          pointer-events: none;
          /* Move logo to 50% between top and heading */
          top: calc(16vh + 17%);
        }
        .mobile-logo img {
          width: 240px !important;
          max-width: 90vw;
          height: auto !important;
          margin: 0 auto !important;
          pointer-events: auto;
        }
      }
    `;
    const scrollRef = useRef(null);
    const whiteButtonStyle = {
      fontSize: '16px',
      padding: '12px 32px',
      fontWeight: '300',
      border: 'none',
      outline: 'none',
      color: '#000',
      background: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)'
    };

    return (
      <div>
        <style>{mobileLogoStyle}</style>
        <div className="hero-section" style={{
          minHeight: '100vh',
          background: 'transparent',
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {isRetro ? (
            <img
              src={assetUrl('RETRO LAND.png')}
              alt="Retro landing"
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: 0
              }}
            />
          ) : (
            <video
              autoPlay
              muted
              loop
              playsInline
              aria-hidden="true"
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: 0
              }}
            >
              <source src={assetUrl('Aluren Landing 2.mp4')} type="video/mp4" />
            </video>
          )}
          {!isRetro && (
            <div
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                height: '10%',
                background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.85) 100%)',
                zIndex: 1,
                pointerEvents: 'none'
              }}
            />
          )}
          {}
          <div className="mobile-logo">
            <img
              src={assetUrl('logo.png')}
              alt="Aluren Dynamics Logo"
            />
          </div>
          <div className="hero-content" style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '6rem 1.5rem 2rem 1.5rem',
            zIndex: 1
          }}>
            <div className="hero-text" style={{ position: 'relative', zIndex: 10, textAlign: 'left', maxWidth: '1200px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0 1.5em', margin: '0 auto' }}>
              {}
              <h1 style={{
                fontSize: 'clamp(1.5rem, 4vw, 3.5rem)',
                fontWeight: '700',
                marginBottom: '1rem',
                lineHeight: '1.1',
                letterSpacing: '0.05em',
                color: 'white',
                marginTop: '0',
                textShadow: '0 2px 10px rgba(0,0,0,0.5)'
              }}>
                <div style={{ color: '#d1d5db' }}>ALUREN DYNAMICS</div>
              </h1>
              {}
              <p style={{
                fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)',
                fontWeight: '300',
                color: '#9ca3af',
                marginBottom: '3rem',
                maxWidth: '600px',
                margin: '0 0 3rem 0',
                lineHeight: '1.6',
                textShadow: isRetro ? '2px 2px 0 rgba(0,0,0,0.6)' : '0 2px 10px rgba(0,0,0,0.5)'
              }}>
                ADVANCING THE ADVENT OF ORBITAL ACCESS
              </p>
              {}
              <div className="hero-cta" style={{ display: 'flex', flexDirection: 'row', gap: '1rem', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap' }}>
                <button
                  style={whiteButtonStyle}
                  onClick={() => { scrollRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' }); }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.4)';
                    e.target.style.background = '#f9f9f9';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.3)';
                    e.target.style.background = '#ffffff';
                  }}
                >
                  EXPLORE SOLUTIONS
                </button>
              </div>
            </div>
            {}
            <div ref={scrollRef} className="hero-scroll" style={{
              position: 'absolute',
              bottom: '2rem',
              left: '50%',
              transform: 'translateX(-50%)',
              textAlign: 'center'
            }}>
              <div
                style={{
                  width: '1px',
                  height: '64px',
                  background: 'linear-gradient(to bottom, #6b7280, transparent)',
                  margin: '0 auto'
                }}
              />
              <div
                style={{
                  marginTop: '8px',
                  fontSize: '12px',
                  color: '#6b7280',
                  letterSpacing: '0.1em'
                }}
              >
                SCROLL
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default HeroSection;